<template>
  <div class="page">

    <SettingsAccount :account="account"/>

    <div v-show="partnerMode">
      <h1>Partner settings</h1>
      Global partner settings affecting to all accounts.
      <SettingsPartner/>
    </div>

  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hint {
  font-size: small;
}
</style>

<script>
import { mapState } from 'vuex'
import SettingsAccount from '@/components/SettingsAccount.vue'
import SettingsPartner from '@/components/SettingsPartner.vue'

export default {
  name: 'settings',
  components: {
    SettingsAccount,
    SettingsPartner
  },
  computed: {
    ...mapState([
      'partnerMode',
      'accountMode',
      'debugMode',
      'account',
      'settings'
    ])
  }
}
</script>
